<template>
    <div class="cigarette-entrust search-page">
        <div class="title">委托查询</div>
        <div class="search-input">
            <a-input-search placeholder="请输入" size="large" @search="onSearch">
                <a-button slot="enterButton">查询</a-button>
            </a-input-search>
        </div>
        <div class="search-content" v-if="searching">
            <div class="nav">
                <div class="left">委托信息</div>
                <div class="right" @click="viewDetail">查看详情</div>
            </div>
            <div class="content">
                <custom-form :panels="formOption" :readonly="true" :fieldsValue="fieldsValue"></custom-form>
                <a-button type="link">查看物流</a-button>
            </div>
        </div>
        <div class="list-content" v-else>
            <tab :tabs="tabs" @setValue="setTabValue"></tab>
            <a-table
                :columns="columns"
                :data-source="tableData"
                :loading="loading"
                :scroll="{ y: 320 }"
                :pagination="pagination"
                @change="handleTableChange"
            >
              <template slot="cssStatus" slot-scope="text">
                <span>{{ statusList[text] }}</span>
              </template>
              <template slot="companyname" slot-scope="text, record">
                <span>{{ record.ext$.companyname }}</span>
              </template>
              <span slot="action" slot-scope="text, record">
                            <a style="display: block" @click="openDetail(record)">详情</a>
                            <a style="display: block">物流信息</a>

                            <a
                                style="display: block"
                                v-if="record.cssStatus === 'unsigned' || record.cssFolderSignStatus === '1'"
                                @click="downloadFile(record)"
                            >下载委托协议</a
                            >
                           <a
                               style="display: block"
                               v-if="record.cssStatus === 'completed'"
                               @click="investigation(record)"
                           >满意度调查</a
                           >
                            <a-upload
                                :multiple="false"
                                :showUploadList="false"
                                accept=".pdf"
                                :customRequest="handleFileChange"
                            >
                                <a
                                    style="display: block"
                                    v-if="record.cssStatus === 'unsigned'"
                                    @click="clickUpload(record)"
                                >上传委托协议</a
                                >
                            </a-upload>
                        </span>
            </a-table>
        </div>
    </div>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import tab from '../../components/tab.vue';
import customForm from '../../components/custom-form.vue';
import service from '../../utils/service';
import {upload} from "../../common/api";

export default {
    components: { tab, customForm },
  data() {
    return {
      searching: false,
      tabValue: 'all',
      locale: zhCN,
      loading: false,
      current: 1,
      pageSize: 10,
      tabs: [
        { value: 'all', text: '全部', selected: true },
        { value: 'prepareAccept', text: '待受理', selected: false },
        { value: 'unsigned', text: '待签订', selected: false },
        { value: 'inspect', text: '检验中', selected: false },
        { value: 'completed', text: '已完成', selected: false }
      ],
      statusList: {
        prepareAccept: '待受理',
        unsigned: '待签订',
        inspect: '检验中',
        completed: '已完成'
      },
      columns: [
        {
          title: '序号',
          width: 60,
          customRender: (text, record, index) => index + 1
        },
        // { title: '委托单号', dataIndex: 'id', align: 'center' },
        {
          title: '委托状态',
          dataIndex: 'cssStatus',
          align: 'center',
          scopedSlots: { customRender: 'cssStatus' }
        },
        {
          title: '委托单位',
          dataIndex: 'companyname',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'companyname' }
        },
        { title: '委托日期', dataIndex: 'createdTime', align: 'center' },
        { title: '样品类型', dataIndex: 'ext$.sampletypename', align: 'center' },
        { title: '合同号', dataIndex: 'contractCode', align: 'center' },
        {
          title: '操作',
          key: 'operation',
          scopedSlots: { customRender: 'action' }
        }
      ],

      searchFields: [
        {
          id: 'search',
          gutter: 0,
          readonly: true,
          fieldGroup: [
            [
              {
                label: '委托单号',
                field: 'id',
                span: 12,
                labelCol: { span: 10 },
                wrapperCol: { span: 14 }
              },
              {
                label: '委托日期',
                field: 'createdTime',
                span: 12,
                labelCol: { span: 10 },
                wrapperCol: { span: 14 }
              },
              {
                label: '委托状态',
                field: 'statusDesc',
                span: 12,
                labelCol: { span: 10 },
                wrapperCol: { span: 14 }
              },
              {
                label: '样品类型',
                field: 'ext$.sampletypename',
                span: 12,
                labelCol: { span: 10 },
                wrapperCol: { span: 14 }
              },
              {
                label: '合同号',
                field: 'contractCode',
                span: 12,
                labelCol: { span: 10 },
                wrapperCol: { span: 14 }
              }
            ]
          ]
        }
      ],

      tableId: '',
      cssFolderId: '',
      searchData: null
    };
  },
    computed: {
        pagination() {
            return {
                total: this.total,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: this.pageSize,
                showTotal(total) {
                    return `总共${total}条`;
                },
                current: this.current
            };
        }
    },

    created() {
        this.getTableData();
    },

    methods: {
        onSearch() {
            this.searching = true;
        },

        getTableData() {
            this.loading = true;
            const p = {
                f: { cssStatus: this.tabValue === 'all' ? '' : this.tabValue, dzyFlag_SEQ: '1' },
                n: this.current,
                s: this.pageSize,
                qf: {},
                o: []
            };
            service.post('/secure/css/action/select-folder-list', JSON.stringify({ p })).then(({ data }) => {
                this.tableData = data.rows;
                this.total = data.total;
                this.loading = false;
            });
        },

        viewDetail() {
            this.searching = false;
        },

        openDetail(d) {
            const folderId = d.cssFolderId;
            const params = {
                folderId
            };
            this.$router.push({ name: 'cigarette-detail', query: params });
        },

        setTabValue(v) {
            this.tabValue = v;
            this.current = 1;
            this.getTableData();
        },
      async downloadFile(val) {
        let fileId = val.unSignedFolderId;
        if(val.cssFolderSignStatus == '1'){
          fileId = val.signedFolderId;
        }
        const res = await service.post(
            `/secure/css/module/online-folders/action/${fileId}/select-css-file`
        );
        const url = location.origin + res.data.downloadUrl;
        window.open(url);
      },
      async investigation(val) {
        let targetId = val.id;
        const url = location.origin + '/investigation?mouldId=888382790404576&targetId=' + targetId;
        window.open(url,'_blank');
      },
      async handleFileChange({ file }) {
        const { data } = await upload({
          name: file.name,
          file,
          targetId: `T_LIMS_ORDER$${this.tableId}`
        });
        if (data) {
          const params = {
            b: [
              'limsFolderServiceImpl',
              [{ id: this.tableId, signedFolderId: data, cssFolderId: this.cssFolderId }]
            ]
          };
          await service.put(`/secure/css/module/online-folders/action/update-folder-sign-info`, params);
          this.$message.success('上传成功！');
          this.getTableData();
        }
      },

      clickUpload(val) {
        this.tableId = val.id;
        this.cssFolderId = val.cssFolderId;
      },
        async handleTableChange(pagination) {
            this.current = pagination.current;
            this.pageSize = pagination.pageSize;
            this.getTableData();
        }
    }
};
</script>
<style lang="scss" scoped></style>
